import script from "./ModalRequestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalRequestForm.vue?vue&type=script&setup=true&lang=ts"

import "./ModalRequestForm.vue?vue&type=style&index=0&id=1ceb1816&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ceb1816"]])

export default __exports__